import React, { useState, useEffect, useCallback } from 'react';
import { Button } from './ui/button';
import { Music } from 'lucide-react';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 50);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0a1128]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Music className="w-6 h-6 text-[#d4af37]" />
            <span className="text-xl font-bold text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
              VjkumarVarma
            </span>
          </div>
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-gray-300 hover:text-[#d4af37] transition-colors duration-300"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('discography')}
              className="text-gray-300 hover:text-[#d4af37] transition-colors duration-300"
            >
              Discography
            </button>
            <button
              onClick={() => scrollToSection('lyrics')}
              className="text-gray-300 hover:text-[#d4af37] transition-colors duration-300"
            >
              Lyrics
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#d4af37] text-[#0a1128] hover:bg-[#c5a572] transition-all duration-300"
            >
              Connect
            </Button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
